import { Block, Flex } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { useTkv2OrderID } from '../../controller/hooks/useTkv2OrderID.ts';
import { useVacantLandSales } from '../../hooks/useVacantLandSales.tsx';
import { selectPropertyIdentificationById } from '../../redux/features/selectors/propertyDataSelectors/propertyIdentificationSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { Typography } from '../../summary/components/Typography.tsx';
import { VacantLandSalesMap } from './VacantLandSalesMap.tsx';
import { VacantLandSalesTable } from './VacantLandSalesTable.tsx';

import './VacantLandSales.scss';

export const VacantLandSales = ({ isPopout }: { isPopout: boolean }) => {
  const orderID = useTkv2OrderID();
  const vacantLandSales = useVacantLandSales();
  const subjectCoordinates = useAppSelector((state) =>
    selectPropertyIdentificationById(state, 'subject'),
  )?.coordinates;

  const [focusedRow, setFocusedRow] = useState<string | undefined>(undefined);

  if (!vacantLandSales || !subjectCoordinates) return null;

  const focusedPropertyIndex = vacantLandSales.findIndex(({ id }) => id === focusedRow);
  const focusedPropertyId =
    focusedPropertyIndex !== -1 ? vacantLandSales[focusedPropertyIndex]?.id : undefined;

  return (
    <Flex flexDirection="column" width="100%" gap="1rem" padding="2rem">
      <Typography variant="h3">Vacant Land Sales</Typography>
      <Flex
        flexDirection="column"
        gap="1rem"
        {...(isPopout ? { className: 'vacant-land-sales-popout' } : {})}
      >
        <VacantLandSalesTable
          vacantLandSales={vacantLandSales}
          orderID={orderID}
          onRowClick={(row) => setFocusedRow(row.id)}
          focusedRowIndex={focusedPropertyIndex}
        />
        <Block height="25rem">
          <VacantLandSalesMap
            vacantLandSales={vacantLandSales}
            focusedPropertyId={focusedPropertyId}
            setFocusedPropertyId={setFocusedRow}
            subjectCoordinates={subjectCoordinates}
          />
        </Block>
      </Flex>
    </Flex>
  );
};
